import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_GOOGLE_AUTH = createFcmConfig('google_auth', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
